<template>
  <div>
    <div class="spreadsheets">
      <Sheet
        v-for="sheet in sheets"
        v-if="isSheetDisplayed(sheet.key)"
        :parentSheet="masterSheetKey"
        :key="sheet.key"
        :sheet="sheet"
        :scopedData="scopedData"
        :sheets="sheets"
        />
    </div>
    <MoreSheets :sheet="data" />
  </div>
</template>

<script>
// components
import Sheet from './Sheet'
import MoreSheets from './MoreSheets'
// helpers
import db from '@/services/db'

export default {
  components: {
    Sheet,
    MoreSheets
  },
  props: {
    data: { type: Object, required: true }
  },
  data () {
    return {
      allSheets: {},
      sheets: {},
      masterSheetKey: '',
      scopedData: {}
    }
  },
  methods: {
    isSheetDisplayed (key) {
      if (key === this.data.key) {
        return !this.data.rootDeleted && key === this.data.activeSheet
      }
      return key === this.data.activeSheet
    },
    flattenSheets () {
      for (let sheet in this.sheets) {
        let subsheets
        if (this.sheets[sheet].subsheets) subsheets = this.sheets[sheet].subsheets

        if (subsheets) {
          delete this.sheets[sheet].subsheets

          for (let subsheet in subsheets) {
            this.sheets[sheet + '.' + subsheet] = subsheets[subsheet]
            this.sheets[sheet + '.' + subsheet].key = sheet + '.' + subsheet
          }
        }
      }
    },
    setRequiredData (masterSheetKey) {
      for (let sheet in this.sheets) {
        if (!this.sheets[sheet].data) this.sheets[sheet].data = { A1: '' }
      }
    },
    setDynamicData (parent) {
      if (parent.scopedData) {
        for (let propName of parent.scopedData) {
          this.scopedData[propName] = parent[propName]
        }
      }

      let sheetsInScope = {}
      for (let sheet in this.sheets) {
        sheetsInScope[sheet] = this.sheets[sheet].data
      }

      this.scopedData = {
        ...this.scopedData,
        ...sheetsInScope
      }
    }
  },
  created () {
    let parent = this.$parent
    let masterSheetKey = this.data.key
    let dashboard = this.$route.params.id

    // set active table key to identify later what sheet to display in list of sheets first
    this.masterSheetKey = masterSheetKey

    // get all sheets
    db.sheets.read(dashboard, (data) => {
      if (!data) return
      this.sheets = data

      this.flattenSheets()
      this.setRequiredData(masterSheetKey)
      this.setDynamicData(parent)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Spreadsheet/index.vue